import React from 'react'
import {
  Form,
  Segment,
  Icon,
  Header,
  Label,
} from 'semantic-ui-react'
// Note: The iconOptions dropdown makes things SUPER-SLOW
//       if we include all icons (hundreds).
//       Three options:
//       1. Slow, with Dropdown, and all icons
//       2. Fast, with Dropdown, and small subset of icons
//       3. Fast, all icons, develop a modal dialog for selecting icons
//import {uniqueIconNames} from './iconNames.js'
//const iconOptions = uniqueIconNames.map(s=>({text: s, value: s, icon: s }));
const iconOptions = [
  'certificate', 'trophy', 'student',
  'check', 'delete',
  'question', 'exclamation',
  'minus', 'plus',
  'thumbs up', 'thumbs down',
  'frown outline', 'meh outline', 'smile outline',
  'star', 'star half',
  'sound', 'microphone',
  'sun', 'moon',
  'circle', 'dot circle', 'pause circle', 'stop circle', 'circle outline',
  'sign in', 'sign out',
  'play', 'pause', 'stop',
  'volume off', 'volume down', 'volume up',
  'battery empty', 'battery quarter', 'battery half', 'battery three quarters', 'battery full',
  'thermometer empty', 'thermometer quarter', 'thermometer half', 'thermometer three quarters', 'thermometer full',

].map(s=>({text: s, value: s, icon: s }));

const colorOptions = [
  'red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'
].map(s=>({text: '', value: s, label: { color: s, empty: true, circular: true }}));

class TypeEditorEnumChoicePane extends React.Component {
  // props:
  // choice
  // onSetEnumChoiceId={newId=>...}
  // onSetEnumChoiceName={newName=>...}
  // onSetEnumChoiceDescription={newDescription=>...}
  // onSetEnumChoiceColor={newColor=>...}
  // onSetEnumChoiceIcon={newIcon=>...}
  // onRemoveEnumChoice={())=>...}
  render() {
    return (
      <Segment inverted color='orange'>
        <Header as='h4'>
          Choice
        </Header>
        <Label
          attached='top right'
          color='red'
          onRemove={this.props.onRemoveEnumChoice}
        />
        <Form.Group>
          <Form.Input
            width={2}
            name='id'
            label='ID'
            value={this.props.choice.id}
            placeholder='Unique ID of this choice'
            onChange={(e, { value })=>this.props.onSetEnumChoiceId(value)}
          />
          <Form.Input
            width={6}
            name='name'
            label='Name'
            value={this.props.choice.name}
            placeholder='Descriptive name of this choice'
            onChange={(e, { value })=>this.props.onSetEnumChoiceName(value)}
          />
          <Form.Dropdown
            width={2}
            fluid
            name='color'
            label='Color'
            placeholder='Pick color'
            selection
            icon={<Icon name='circle' color={this.props.choice.color}/>}
            options={colorOptions}
            value={this.props.choice.color}
            onChange={(e, { value })=>this.props.onSetEnumChoiceColor(value)}
          />
          <Form.Dropdown
            width={4}
            fluid
            name='icon'
            label='Icon'
            placeholder='Pick icon'
            labeled
            search
            selection
            options={iconOptions}
            value={this.props.choice.icon}
            onChange={(e, { value })=>this.props.onSetEnumChoiceIcon(value)}
          />
          <Form.Button
            width={2}
            label='&nbsp;'
            floated='right'
            type='button'
            color={this.props.choice.color}
            icon={<Icon name={this.props.choice.icon}/>}
          />
        </Form.Group>
        <Form.TextArea
          name='description'
          label='Description'
          value={this.props.choice.description}
          placeholder='Description of this choice'
          onChange={(e, { value })=>this.props.onSetEnumChoiceDescription(value)}
        />
      </Segment>
    );
  }
}

export default TypeEditorEnumChoicePane